<template>
    <div class="add-artifact pb-2">
        <div class="title-body ps-3 py-2">
            Thêm hiện vật
        </div>
        <div class="mt-3">
            <div class="form-artifact height-body pb-3 mx-3">
                <div>
                    <label for="title" class="form-label mb-1">Tên hiện vật</label>
                    <vue-editor v-model="form.title" :editorToolbar="customToolbar" id="title-artifact"></vue-editor>
                    <div class="text-error ms-1" v-if="!form.title">{{ err.title }}</div>
                </div>
                <div class="form-check form-switch mt-3">
                    <input class="form-check-input" type="checkbox" role="switch" id="imgVertical" v-model="form.vertical">
                    <label class="form-check-label" for="imgVertical">Hiện vật ảnh chân dung</label>
                </div>
                <div class="form-check form-switch mt-3">
                    <input class="form-check-input" type="checkbox" role="switch" id="imgPopup" v-model="form.popup">
                    <label class="form-check-label" for="imgPopup">Hiện vật ảnh full màn hình</label>
                </div>
                <div class="thumb-img mt-3">
                    <div class="mb-1">Ảnh đại diện hiện vật</div>
                    <file-pond
                        class="custom-pond"
                        name="image"
                        ref="pond"
                        label-idle="Kéo hình ảnh hoặc chọn"
                        accepted-file-types="image/jpeg, image/png"
                        :server="`${url}/api/upload`"
                        v-model="thumbImg"
                        imagePreviewHeight="200"/>
                </div>
                <div class="list-group list-enable justify-content-between mt-3">
                    <label class="list-group-item">
                        <input class="form-check-input me-1" type="checkbox" v-model="status.threed" @change="check($event, 'threed')">
                        Thêm link 3D
                    </label>
                    <label class="list-group-item">
                        <input class="form-check-input me-1" type="checkbox" v-model="status.youtube" @change="check($event, 'youtube')">
                        Thêm link Youtube
                    </label>
                    <label class="list-group-item">
                        <input class="form-check-input me-1" type="checkbox" v-model="status.image">
                        Thêm ảnh
                    </label>
                    <label class="list-group-item">
                        <input class="form-check-input me-1" type="checkbox" v-model="status.content" @change="check($event, 'content')">
                        Thêm nội dung
                    </label>
                    <label class="list-group-item">
                        <input class="form-check-input me-1" type="checkbox" v-model="status.audio" @change="check($event, 'audio')">
                        Thêm audio
                    </label>
                </div>
                <div class="mt-3" v-if="status.threed">
                    <label for="threed" class="form-label mb-1">Link 3D</label>
                    <input type="text" class="form-control" id="threed" v-model="form.threed">
                </div>
                <div class="mt-3" v-if="status.youtube">
                    <label for="youtube" class="form-label mb-1">Link Youtube</label>
                    <input type="text" class="form-control" id="youtube" v-model="form.youtube">
                </div>
                <div class="mt-3" v-if="status.audio">
                    <label for="youtube" class="form-label mb-1">Link Audio</label>
                    <input type="text" class="form-control" id="youtube" v-model="form.audio">
                </div>
                <div class="mt-3" v-if="status.content">
                    <label for="description" class="form-label mb-1">Nội dung</label>
                    <vue-editor v-model="form.content" :editorToolbar="customToolbar"></vue-editor>
                </div>
                <div class="mt-3" v-if="status.image">
                    <p class="mb-1">Thêm ảnh</p>
                    <file-pond
                        class="custom-pond"
                        name="image"
                        ref="pond"
                        label-idle="Kéo hình ảnh(nhiều) hoặc chọn"
                        allow-multiple="true"
                        accepted-file-types="image/jpeg, image/png"
                        :server="`${url}/api/upload`"
                        v-model="listImg"/>
                </div>
                <div class="btn-comfirm text-center mt-5 pb-4">
                    <button  class="btn btn-success" @click="addArtifact()">Thêm hiện vật</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vueFilePond from "vue-filepond";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import { VueEditor } from "vue2-editor";
const FilePond = vueFilePond(FilePondPluginImagePreview, FilePondPluginFileValidateType);
export default {
    components: {
        FilePond, VueEditor,
    },
    data() {
        return {
            status: {
                threed: false,
                youtube: false,
                image: false,
                content: false,
                audio: false,
            },
            form: {
                title: '',
                threed: '',
                youtube: '',
                content: '',
                audio: '',
                images: '',
                thumbImg: '',
                vertical: 0,
                popup: 0,
            },
            err: {
                title: '',
            },
            listImg: [],
            thumbImg: '',
            url: process.env.VUE_APP_API_URL,
            customToolbar: [
                ["bold", "italic", "underline"],
                [{ align: "" },{ align: "center" },{ align: "right" },{ align: "justify" }],
                [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
                [{ indent: "-1" }, { indent: "+1" }],
                ["code-block"],
            ],
        }
    },
    methods: {
        check(e, v) {
            if(v == 'threed') {
                if(e.target.checked == false) {
                    this.form.threed = '';
                }
            } else if(v == 'youtube') {
                if(e.target.checked == false) {
                    this.form.youtube = '';
                }
            } else if(v == 'audio') {
                if(e.target.checked == false) {
                    this.form.audio = '';
                }
            } else if(v == 'content') {
                if(e.target.checked == false) {
                    this.form.content = '';
                }
            }
        },
        async addArtifact() {
            let list = [];
            this.listImg.map(function(value, key) {
                let getImg = JSON.parse(value.serverId);
                list.push(getImg);
            })

            this.form.images = list.toString();

            if(this.thumbImg != '') {
                this.form.thumbImg = JSON.parse(this.thumbImg[0].serverId);
            }

            await apiPost('/artifact/add', {
                title: this.form.title,
                link_3d: this.form.threed,
                youtube: this.form.youtube,
                images: this.form.images,
                audio: this.form.audio,
                text: this.form.content,
                thumb_img: this.form.thumbImg,
                img_vertical: this.form.vertical,
                popup_full: this.form.popup,
            }).then(res => {
                this.$toast.success(res.message, {
                    timeout: 3000,
                });
                this.$router.push({
                    name: 'artifact',
                });
            }).catch(err => {
                this.err.title = err.data.title[0];
                console.log(err);
            })
        }
    }
}
</script>

<style lang="scss">
.add-artifact {
    .custom-pond {
        .filepond--credits {
            display: none !important;
        }
        .filepond--list {
            .filepond--item {
                width: 24%;
            }
        }
    }
    .list-enable {
        flex-direction: unset !important;
        .list-group-item {
            border: none !important;
            padding: 0 !important;
        }
    }
    .btn-comfirm {
        button {
            padding: 10px 100px;
        }
    }
    .thumb-img {
        width: 300px;
        .filepond--item {
            width: 100% !important;
        }
    }
}
</style>
